import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    SelectField,
    EditButton,
    ShowButton,
    CardActions,
    CreateButton,
    FunctionField,
    useListContext
} from 'react-admin';
import DivisionActionButton from '../component/DivisionActionButton'
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Filter from './Filter';
import UIButton from "@material-ui/core/Button";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const translateForStatus = {
        INACTIVE: "НЕ АКТИВНА",
        ACTIVE: "АКТИВНА"
}

const handleXlsxClick = (scope) => {
    window.location = process.env.REACT_APP_BASE_ENTRYPOINT + '/divisions/xlsx?token=' + localStorage.getItem('session');
}

const DivisionActions = ({
                         bulkActions,
                         basePath,
                         currentSort,
                         displayedFilters,
                         exporter,
                         filters,
                         filterValues,
                         onUnselectItems,
                         resource,
                         selectedIds,
                         showFilter,
                         total
                     }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        <CreateButton basePath={basePath} label={"Створити"}/>
        <UIButton size="small" color="primary" onClick={handleXlsxClick} startIcon={<ArrowDownwardIcon />}>
            Download Excel
        </UIButton>
    </CardActions>
);

const Empty = () => {
    const {basePath} = useListContext();
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Мої аптеки - відсутні
            </Typography>
            <CreateButton basePath={basePath} label="створити" />
        </Box>
    );
};

export const DivisionList = (props) => (
    <List {...props}
          filters={<Filter />}
          empty={<Empty />}
          bulkActionButtons={false}
          className="list-styles"
          perPage={25}
          title="Мої аптеки"
          actions={<DivisionActions/>}
    >
        <Datagrid>
            <TextField sortable={false} label="Назва" source="name" />
            <SelectField sortable={false} label="Тип" source="type" choices={[
                { id: 'DRUGSTORE', name: 'Аптека' },
                { id: 'DRUGSTORE_POINT', name: 'Аптечний пункт' },
                { id: 'AMBULANT_CLINIC', name: 'Амбулаторія' },
                { id: 'CLINIC', name: 'Філія (інший відокремлений підрозділ)' },
                { id: 'FAP', name: 'ФАП' },
                { id: 'LICENSED_UNIT', name: 'Місце провадження діяльності' }
            ]} />
            <FunctionField
                label="Статус"
                render={record => `${translateForStatus[record.status]}`}
            />

            <ShowButton label={"Переглянути"} />
            <EditButton label={"Редагувати"} />
            <DivisionActionButton/>
        </Datagrid>
    </List>
);

export default DivisionList;
